export function lerp(start, end, amt){
    return (1 - amt) * start + amt * end
}

export function random(min, max) {
    return Math.random() * (max - min) + min;
}

export function roundRandom(min, max) {
    return Math.ceil(random(min-1,max));
}